import { TextInput } from '../../index';

export function Textarea(props) {
  return <TextInput {...props} multiline />;
}

export default Textarea;
